import moment from 'moment';
import 'moment-timezone';

export default {
  install(app) {
    app.config.globalProperties.$moment = moment
    app.config.globalProperties.$moment.tz = moment.tz
  },
}
